import { render } from "./TestimonyModal.vue?vue&type=template&id=16c3e220"
import script from "./TestimonyModal.vue?vue&type=script&lang=js"
export * from "./TestimonyModal.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import UploadImage from "@/components/UploadImage.vue";
import InputText from "@/components/InputText.vue";
import InputTextArea from "@/components/InputTextArea.vue";
import ButtonCta from "@/components/ButtonCta.vue";
import ButtonCancel from "@/components/ButtonCancel.vue";
script.components = Object.assign({}, { UploadImage, InputText, InputTextArea, ButtonCta, ButtonCancel }, script.components);